export default {
  parameter: {
    selectParameter: 'Select parameter',
    name: 'Enter name',
    min: 'Min.',
    max: 'Max.',
  },
};
